// extracted by mini-css-extract-plugin
export default {"base":"InlineVideo-module--base--87523","cover":"InlineVideo-module--cover--2526b","awards":"InlineVideo-module--awards--91de0","award":"InlineVideo-module--award--b81f1"};